import {  Component,  Input,  OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import {    ControlContainer, NgForm } from '@angular/forms';
import { Supplier, SupplierStatut }  from '../../all-models';
import moment from 'moment';
import { SharedDataService } from '../../all-services';
import { SuppliersService } from '../../Services/suppliers.service';
import { SupplierAccHisto } from '../../Models/SupplierAccHisto';

@Component({
  selector: 'accidentologie',
  templateUrl: './accidentologie.component.html',
  styleUrls: ['./accidentologie.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ]
})
export class AccidentologieComponent implements OnInit,OnChanges  {

  @Input() readonly:boolean = false;
  @Input() supplier:Supplier=new Supplier();
  //@ViewChild('ngFrmAcc') frmAcc : NgForm;
  
  SupplierAccHistory: SupplierAccHisto[]=[];
  
  public fromDate : Date =  moment().add(-1,'year').startOf('year').utc().toDate(); 
  public toDate : Date = moment().add(-1,'year').endOf('year').utc().toDate(); 
  
  constructor(
    private sharedDataSvc:SharedDataService,
     private supplierSvc:SuppliersService,
  public controlContainer: ControlContainer
) { }

get frmAcc(): NgForm {
  return this.controlContainer as NgForm;
}

  get accDatDebMax() : Date {
    if (this.frmAcc?.controls['AccDatFin']?.valid) {
      return this.supplier?.AccDatFin;
    } else {
      return this.toDate;
    }
  }
  get accDatFinMin() : Date {
    if (this.frmAcc?.controls['AccDatDeb']?.valid) {
      return this.supplier?.AccDatDeb;
    } else {
      return this.fromDate;
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['supplier']){
      if (this.supplier.AccDatDeb == null) {
        this.supplier.AccDatDeb = this.fromDate;
      } else {
        this.supplier.AccDatDeb = new Date(this.supplier.AccDatDeb);
      }
      if (this.supplier.AccDatFin == null) {
        this.supplier.AccDatFin = this.toDate;
      } else  {
        this.supplier.AccDatFin = new Date(this.supplier.AccDatFin);
      }
      this.reloadSupplierAccHistory();
    }
  }

  ngOnInit(): void { }




  public TGCalc():number {
    const nbH : number = (this.supplier.NbWorkHours ||0);
    const nb2 : number =(this.supplier.NbWorkAccLostDays||0);
    if (nbH==0) return 0;
    return ( nb2 / nbH * 1000).roundNbDec(2);
  }
  public TF1Calc():number {
    const nbH : number = (this.supplier.NbWorkHours||0);
    const nb2 : number =(this.supplier.NbWorkAccStop||0);
    if (nbH==0) return 0;
    return ( nb2 / nbH * 1000000).roundNbDec(2);
  }
  public TF2Calc():number {
    const nbH : number = (this.supplier.NbWorkHours||0);
    const nb2 : number =(this.supplier.NbWorkAccStop||0)+(this.supplier.NbWorkAccNoStop||0);
    if (nbH==0) return 0;
    return ( nb2 / nbH * 1000000).roundNbDec(2);
  }
  public get supplierStatut(): SupplierStatut | null {
    if (!this.supplier) {
        return null;
    } else {
        return this.supplierSvc.lstStatut.find(s => s.Id == this.supplier.StatutId);
    }
}
  get relanceAccAllowed():boolean{
    return this.supplierStatut?.Cod=='800' && this.accIncomplet && this.sharedDataSvc.checkProfilAccessPafSettings('ACCES_PROFILS/RELANCE_ACCIDENTOLOGIE');
  }

  get accIncomplet():boolean {
    return this.frmAcc?.invalid;
  }

  public relance():void {
    if ((this.supplier?.Id||0) == 0) return;
    this.sharedDataSvc.confirm("Confirmez-vous l'envoi du mail de relance accidentologie au fournisseur?",
    ()=>{
      this.relanceConfirmee();
    },null);
  }

  private relanceConfirmee():void{
    this.supplierSvc.RelanceAccidentologie(this.supplier?.Id).subscribe(
      {
        next:result=>{
        this.sharedDataSvc.informe(result.Message);
        },
        error:(error:any)=>{
        this.sharedDataSvc.alert(`Erreur : ${error.error || error}`);
    }
  })
  }
  public reloadSupplierAccHistory (): void{
    const minYear:String = moment().add(-4,'year').format('YYYY'); 
      this.supplierSvc.SupplierAccHistory(this.supplier?.Id)
      .subscribe(results=> {
        this.SupplierAccHistory = results.filter(r=>r.Year>=minYear);
        this.SupplierAccHistory.sortOnDateDesc('AccDatDeb');
      });
  }

  get accHistoryVisible():boolean {
    return this.supplierStatut?.Cod=='800';
  }
}


